import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  input: {
    backgroundColor: '#ff8c691a',
    '& input': {
      padding: '0 !important',
      fontSize: 16,
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
    },

    '& .MuiAutocomplete-inputRoot': {
      padding: '15px !important',
    },
    '& .MuiAutocomplete-inputRoot:hover .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #FF8C69',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #FF8C69',
      borderRadius: 0,
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      top: 0,
      border: '1px solid #FF8C69',
      borderRadius: 0,
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline legend': {
      display: 'none',
    },
  },

  filledInput: {
    backgroundColor: '#ffffff',
    '& .MuiAutocomplete-inputRoot': {
      padding: '8px !important',
    },
  },

  chipItem: {
    width: '100%',
    justifyContent: 'space-between',
    margin: 4,
    padding: '5px 0',
    minHeight: 32,
    height: 'auto',
    color: '#ffffff',
    fontSize: 16,
    backgroundColor: '#46a0a0',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    '& .MuiChip-label': {
      fontSize: 16,
      whiteSpace: 'initial',
      wordBreak: 'break-word',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
    },
    '& .MuiChip-deleteIcon': {
      color: '#ffffff',
    },
    '.rtl & .MuiChip-deleteIcon': {
      margin: '0 -6px 0 5px',
    },
  },
  list: {
    paddingLeft: 0,
    maxHeight: 200,
    overflowY: 'auto',
    '.rtl &': {
      paddingRight: 0,
    },
    '& li[aria-selected="true"]': {
      backgroundColor: '#ff8c691a',
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
}));
